<ng-container *ngTemplateOutlet="mainGroupsTemplate; context: { menuItems: menuItems }" />

<ng-template
  #mainGroupsTemplate
  let-menuItems="menuItems"
>
  <ul class="aos-side-menu__main-items">
    <ng-container *ngTemplateOutlet="menuItemsTemplate; context: { children: menuItems, level: 0 }" />
  </ul>
</ng-template>

<ng-template
  #menuItemsTemplate
  let-children="children"
  let-level="level"
>
  @for (item of children; track item.title) {
    <li>
      @if (!item.hidden) {
        <ng-container *ngTemplateOutlet="anchorTemplate; context: { item: item, level: level }" />
        @if (item.expanded) {
          <ul>
            <ng-container *ngTemplateOutlet="menuItemsTemplate; context: { children: item.children, level: 1 }" />
          </ul>
        }
      }
    </li>
  }
</ng-template>

<ng-template
  #anchorTemplate
  let-item="item"
  let-level="level"
>
  @if (item.isSection) {
    <a
      class="aos-side-menu-section"
      tabindex="0"
      (click)="toggleMenuHeader($event, item)"
      (keydown.enter)="toggleMenuHeader($event, item)"
    >
      {{ item.title | translate | uppercase }}
      <ui-icon
        class="aos-side-menu-expand-button__icon"
        [color]="expandButtonIconColor"
        [name]="item.expanded ? 'navigate_up' : 'navigate_down'"
        [size]="expandButtonIconSize"
      />
    </a>
  } @else if (item.isNonNavigable) {
    <div
      role="button"
      tabindex="0"
      [ngClass]="getClassBindings(item.selected, level)"
      (click)="toggleMenuItem($event, item)"
      (keydown.enter)="toggleMenuItem($event, item)"
      (keydown.space)="toggleMenuItem($event, item)"
    >
      <ng-container *ngTemplateOutlet="itemContainerTemplate; context: { item: item, level: level }" />
    </div>
  } @else if (item.hasExternalLink) {
    <a
      [ngClass]="getClassBindings(item.selected, level)"
      [href]="item.path"
      target="_blank"
      (click)="handleClick(item)"
    >
      <ng-container *ngTemplateOutlet="itemContainerTemplate; context: { item: item, level: level }"></ng-container>
    </a>
  } @else {
    <a
      [ngClass]="getClassBindings(item.selected, level)"
      routerLinkActive=""
      [routerLinkActiveOptions]="{
        paths: 'subset',
        queryParams: 'ignored',
        fragment: 'ignored',
        matrixParams: 'ignored'
      }"
      [routerLink]="item.path"
      (click)="handleClick(item)"
    >
      <ng-container *ngTemplateOutlet="itemContainerTemplate; context: { item: item, level: level }"></ng-container>
    </a>
  }
</ng-template>

<ng-template
  #itemContainerTemplate
  let-item="item"
  let-level="level"
>
  @if (level === 0) {
    <ng-container *ngTemplateOutlet="itemContentTemplate; context: { icon: item.icon, title: item.title }" />
  } @else {
    <ng-container *ngTemplateOutlet="subitemContentTemplate; context: { title: item.title }" />
  }
  @if (item.children.length) {
    <button
      class="aos-side-menu-expand-button"
      (click)="$event.stopPropagation()"
    >
      <ui-icon
        class="aos-side-menu-expand-button__icon"
        [color]="expandButtonIconColor"
        [name]="item.expanded ? 'navigate_up' : 'navigate_down'"
        [size]="expandButtonIconSize"
        (click)="toggleMenuItem($event, item)"
      />
    </button>
  }
</ng-template>

<ng-template
  #itemContentTemplate
  let-icon="icon"
  let-title="title"
>
  <div class="aos-side-menu-item__content">
    <ui-icon
      class="aos-side-menu-item__icon"
      [color]="itemIconColor"
      [name]="icon"
      [size]="itemIconSize"
    />
    <span>{{ title | translate }}</span>
  </div>
</ng-template>

<ng-template
  #subitemContentTemplate
  let-title="title"
>
  <div class="aos-side-menu-subitem__content">
    <ui-icon
      class="aos-side-menu-subitem__icon"
      [color]="subitemIconColor"
      [name]="subitemIconName"
      [size]="subitemIconSize"
    />
    <span>{{ title | translate }}</span>
  </div>
</ng-template>
